<template>
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;" class="layout-column">

    <div v-if="!showDetails"
         class="layout-column flex ma-1"
         style="border-radius:4px;position:relative;"
         v-bind:style="{background: compColor.contentFrame}">

      <div v-bind:style="{'z-index': '4'}" class="layout-row layout-align-center-center pa-1">
        <div class="layout-row">
          <lx-btn small classes="mr-1 text-none"
                  @click="getDataForTable()"
                  icon="refresh"
                  :tooltip="$t('NEWS.BUTTONS.RELOAD')"
                  :disabled="tableObj.loading"
                  hide-label></lx-btn>
          <lx-btn block classes="mr-1 text-none"
                  width="125px"
                  @click="openNewsDetails()"
                  icon="mdi-text-box-plus-outline"
                  :tooltip="$t('NEWS.BUTTONS.ADD')"
                  :label="$t('NEWS.BUTTONS.ADD')"></lx-btn>
        </div>

        <div class="flex"></div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="flex layout-column lx-delivery-background pa-1" style="overflow-y: hidden">

        <div class="elevation-3 flex layout-column pa-1" style="border-radius: 6px;"
             :style="{'background': compColor.lxExpansion.background}">
          <div style="border-radius: 6px;border: 1px solid rgba(0,0,0,0.1);" class="flex layout-column">
            <lx-data-table
              tableName="NewsList"
              v-model="tableObj.selection"
              :items="items"
              :headers="tableObj.headers"
              :loading="tableObj.loading"
              :tableOptions="tableObj.options"
              :hideContextFilter="true"
              @changeOptions="changeTableOptions"
              @rowClicked="openNewsDetails"
              @openContextOnRowClick="openContextOnRowClick">

              <template #cellrenderer="{ value }">
                <!-- icon renderer -->
                <div v-if="value.f.renderer === 'delete' && value.i.isEditable" style="height:35px;" class="layout-column layout-align-center-center">
                  <v-icon
                    :class="compColor.isInDarkMode ? compColor.primeHighlightClass : compColor.primeClass"
                    size="20"
                    @click="openDeleteDialog(value.i, $event)"
                    style="cursor: pointer;">
                    mdi-delete-forever
                  </v-icon>
                </div>
              </template>
            </lx-data-table>
          </div>
        </div>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <div class="layout-row pa-0">
        <lx-pagination :page-name="'NewsList'"
                       :page-options="pagingOptions"
                       :page-change="getDataForTable">
        </lx-pagination>
      </div>
    </div>

    <news-details v-if="showDetails"
                  @set-show-details="setShowDetails"
                  :newsId="selectedId">
    </news-details>

  </div>
</template>
<script>
import LxPagination from '../../../components/lx_pagination/LxPagination'
import NewsDetails from './NewsDetails'

export default {
  name: 'NewsList',
  data () {
    return {
      tableObj: {
        loading: false,
        selection: null,
        options: {
          sortBy: ['validFromDate'],
          sortDesc: [false]
        },
        headers: [
          {
            text: '',
            width: '20px',
            renderer: 'delete'
          },
          {
            text: this.$t('NEWS.LIST_TABLE.VALID_FROM_DATE'),
            value: 'validFromDate',
            width: '150px',
            renderer: 'date',
            sortable: true
          },
          {
            text: this.$t('NEWS.LIST_TABLE.VALID_TO_DATE'),
            value: 'validToDate',
            width: '150px',
            renderer: 'date',
            sortable: true
          },
          {
            text: this.$t('NEWS.LIST_TABLE.HEADLINE'),
            value: 'headline',
            width: '500px',
            sortable: true
          }
        ]
      },
      items: [],
      pagingOptions: {
        limit: 50,
        skip: 0,
        count: 0
      },
      showDetails: false,
      selectedId: null
    }
  },

  components: {
    NewsDetails,
    LxPagination
  },

  created () {
    if (this.userIsRoot) {
      this.tableObj.headers.push(
        {
          text: this.$t('NEWS.LIST_TABLE.CREATED_BY'),
          value: 'createdBy',
          width: '300px',
          visible: true
        })
    }
    this.getDataForTable()
  },

  mounted () {
    if (typeof this.createCategory === 'function' && typeof this.addEntryToMenu === 'function') {
      this.createCategory('NewsDataTable')
      this.addEntryToMenu({
        type: 'NewsDataTable',
        value: [
          {
            icon: true,
            iconName: 'mdi-clipboard-edit-outline',
            title: 'Bearbeiten',
            action: this.openNewsDetails
          },
          {
            icon: true,
            iconName: 'mdi-delete-forever',
            title: 'Löschen',
            action: this.openDeleteDialog
          },
        ]
      })
    }
  },

  methods: {
    openContextOnRowClick (event, item) {
      if (item) {
        this.$lxContext.open(event, 'NewsDataTable', item, this.isLxContextDisabled)
      }
    },

    getDataForTable (options) {
      if (this.tableObj.loading) return
      this.tableObj.loading = true

      if (options && typeof options.skip === 'number') {
        this.pagingOptions.skip = options.skip
      }
      if (options && options.limit) {
        this.pagingOptions.limit = options.limit
      }

      let opts = {
        skip: this.pagingOptions.skip,
        limit: this.pagingOptions.limit
      }

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      this.$http.get('/dashboard/news/overview?config={"opts":' + JSON.stringify(opts) + '}')
        .then(res => {
          if (res.data) {
            this.items = res.data.result || []

            this.pagingOptions.count = res.data.count || 0
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    },

    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    openNewsDetails (params) {
      this.selectedId = null

      if (params) {
        this.selectedId = params._id
      }
      this.setShowDetails(true)
    },

    deleteNews (params) {
      if (params) {
        this.$http.delete('/dashboard/news/' + params._id)
          .then(() => {
            this.getDataForTable()
          })
          .catch(this.NotifyError)
      }
    },

    openDeleteDialog (params, event) {
      if (event) {
        event.stopPropagation()
      }

      this.DialogConfirm(
        this.$t('CONFIRM_DELETE_DIALOG.HEADER'),
        this.$t('CONFIRM_DELETE_DIALOG.MESSAGE_DELETE_FORM'),
        { ok: this.$t('buttons.delete.value'), cancel: this.$t('buttons.cancel.value') })
        .then(() => {
          this.deleteNews(params)
        })
        .catch(() => {
          // nothing to do
        })
    },

    setShowDetails (showDetails) {
      if (!showDetails) {
        this.getDataForTable()
      }
      this.showDetails = showDetails
    }
  },

  computed: {
    userIsRoot () {
      return this.authStore.getters.userIsAdmin
    },
  },

  watch: {
    '$route' (to) {
      if (to.name === 'NewsList' && !this.showDetails) {
        // reload table
        this.getDataForTable()
      }
    }
  }
}
</script>
